require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-af-bs-d-3.json") })
        }
      }, "path---package-unpublished-af-bs-d-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-af-bs-d-3!./.cache/json/package-unpublished-af-bs-d-3.json
// module id = 928
// module chunks = 231608221292675